export const ONBOARDING_CONFIG = {
  CLOSED: -1,
  SOCIAL_COIN: 0,
  SWEEP_COIN: 1,
  REDEEM: 2,
  REWARDS: 3,
  DAILY_BONUS: 4,
  CLAIM_REWARD: 5,
  START_GAME: 6,
  COINS_SELECT: new Set([0, 1]),
  MENU_ACTIONS: new Set([2, 3]),
  BONUS_CLAIMING: new Set([4, 5]),
  ANIMATION_DELAY: 140,
  CLAIMING_DELAY: 3000,
} as const;

export enum INTERACTIVE_GUIDE_EVENTS_ENUM {
  WELCOME = 'welcome',
  GAME_MODES = 'game_modes',
  CC_MODE = 'cc_mode',
  SLOT = 'slot',
  FIRST_CC_SPIN = 'first_cc_spin',
  SECOND_CC_SPIN = 'second_cc_spin',
  TOGGLE_SWITCH = 'toggle_switch',
  SC_MODE = 'sc_mode',
  FIRST_SC_SPIN = 'first_sc_spin',
  SECOND_SC_SPIN = 'second_sc_spin',
  THIRD_SC_SPIN = 'third_sc_spin',
  HOME = 'home',
  DESKTOP_MENU = 'desktop_menu',
  REDEEM = 'redeem',
  REDEEM_CONVERSION = 'redeem_conversion',
  STORE = 'store',
  ALL_SET = 'all_set',
  FINISH = 'finish',
}
